import { Button } from 'antd';
import { useStore } from '../store/store';

// Overlay plein écran quand le back a révoqué cette session (même user
// connecté sur un autre onglet/appareil, plus récent). Lecture seule
// définitive jusqu'à rechargement — pas de reprise automatique, la session
// active vit ailleurs. Complété par le gel logique côté store
// (editFreezeHolder → sessionRevoked).
export const SessionRevokedOverlay = () => {
  const revoked = useStore((s) => s.sessionRevoked);

  if (!revoked) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        // Au-dessus des drawers/modals antd (~1000), des bannières collab (2000)
        // et des barres flottantes des blocs et des textes (9998-9999).
        zIndex: 10001,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
      }}
    >
      <span style={{ fontWeight: 600, color: '#333', textAlign: 'center' }}>
        Ce document est ouvert dans un autre onglet ou appareil.
        <br />
        Cet onglet est passé en lecture seule.
      </span>
      <Button type='primary' onClick={() => window.location.reload()}>
        Recharger
      </Button>
    </div>
  );
};

export default SessionRevokedOverlay;
